import "./contents.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {ContentsSlide} from "../../../../modals/types/content";

const Contents = (item: ContentsSlide) => {
    return (
        <div className="row Contents">
            <div className="col-lg-6 col-12 mb-3">
                <img src={item.image} alt="" className="img-fluid Contents-Image"/>
            </div>
            <div className="col-lg-6 col-12 mb-3">
                <h5 className="pt-1 pb-3">{item.title}</h5>
                <span className="gray-text font-light">
                    <img src={require("../../../../assets/images/icons/Author.svg").default} alt=""
                         className="img-fluid"/>
                    &nbsp;&nbsp;
                    {item.author}
                </span>
                <span className="gray-text font-light pe-4">
                    <img src={require("../../../../assets/images/icons/Calendar.svg").default} alt=""
                         className="img-fluid"/>
                    &nbsp;&nbsp;
                    {item.date}
                </span>
                <p className="gray-text font-light pt-3">
                    {item.desc}
                </p>
                <div className="text-end">
                    <a href={""} className="Article-Link nav-link red-text pt-2">
                        مشاهده &nbsp; <ArrowBackIosIcon/>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Contents;